var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-table",
        { staticClass: "order-list" },
        [
          _c("div", { staticClass: "text_medium" }, [
            _vm._v(
              _vm._s(
                _vm.type === _vm.ORDER_TYPES.buy
                  ? _vm.i18n.trd_ask()
                  : _vm.i18n.trd_bid()
              )
            )
          ]),
          _vm._v(" "),
          _vm.list.length
            ? [
                _c(
                  "md-table-row",
                  [
                    _c("md-table-head", { staticClass: "order-list__cell" }, [
                      _vm._v(
                        _vm._s(
                          _vm.type === _vm.ORDER_TYPES.buy
                            ? _vm.i18n.trd_want()
                            : _vm.i18n.trd_order()
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", { staticClass: "order-list__cell" }, [
                      _vm._v(
                        _vm._s(
                          _vm.type === _vm.ORDER_TYPES.buy
                            ? _vm.i18n.trd_order()
                            : _vm.i18n.trd_want()
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", { staticClass: "order-list__cell" }, [
                      _vm._v(_vm._s(_vm.i18n.trd_price()))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function(order, i) {
                  return [
                    _c(
                      "md-table-row",
                      {
                        key: i + "-order-row",
                        staticClass: "order-list__row",
                        on: {
                          click: function($event) {
                            return _vm.matchOrder(order)
                          }
                        }
                      },
                      [
                        _c(
                          "md-table-cell",
                          { staticClass: "order-list__cell" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.roundCurrency(
                                  order.baseAmount,
                                  order.baseAssetCode
                                )
                              ) +
                                " " +
                                _vm._s(order.baseAssetCode)
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "order-list__cell" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.roundCurrency(
                                  order.quoteAmount,
                                  order.quoteAssetCode
                                )
                              ) +
                                " " +
                                _vm._s(order.quoteAssetCode)
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "order-list__cell" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.roundCurrency(
                                  order.price,
                                  order.quoteAssetCode
                                )
                              ) +
                                " " +
                                _vm._s(order.quoteAssetCode)
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                })
              ]
            : [
                _c(
                  "div",
                  { staticClass: "container__no-data" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_large" }, [
                      _vm._v(_vm._s(_vm.i18n.trd_no_orders_history()))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text_description text_margin text_medium"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.type === _vm.ORDER_TYPES.buy
                              ? _vm.i18n.trd_here_will_be_the_order_ask_list()
                              : _vm.i18n.trd_here_will_be_the_order_bid_list()
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3ed36e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3ed36e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/orders/Orders.List.vue
// module id = DREn
// module chunks = 1